import AvailabilityProvider from "./AvailabilityProvider";
import { StartTime } from './TimesProvider'
import DateService from '../services/DateService'

export class AltSlot {
    date: Date
    times: StartTime[] = []
    valid: boolean

    constructor (data: any) {
        this.date = new Date(data.date)
        this.valid = !!data.valid

        data.times.forEach((time: any) => {
            this.times.push(new StartTime(time))
        })
    }
}

export default class AlternativesProvider extends AvailabilityProvider {
    private buildBookingParams (): { [index in string] : any } {
        return {
            type: this.booking.type!.id,
            num_people: this.booking.pax,
            date: DateService.formatDateForAPI(this.booking.date!),
            action: 'checkAlternativeDates'
        }
    }

    requestAlternatives (offset: number = 0): Promise<AltSlot[]> {
        const url = this._buildUrl(this.booking.venue!)
        let params = this.buildBookingParams()

        params.offset = offset

        const requestUrl = url + this.objToParams(params)

        return this.get(requestUrl)
            .then((response) => {
                const payload = response.data.payload
                let slots: AltSlot[] = []

                payload.forEach((altSlot: any) => {
                    slots.push(new AltSlot(altSlot))
                })

                return slots
            })
    }
}


// WEBPACK FOOTER //
// ./src/services/AlternativesProvider.ts